import { ChangeDetectorRef, Component, HostListener } from "@angular/core";
import { CommonService } from "src/app/services/common/common.service";
import { MatTableDataSource } from "@angular/material/table";
import { TimeClockRequestComponent } from "../time-clock-request/time-clock-request.component";
import { MatDialog } from "@angular/material/dialog";
import { JobInsightComponent } from "../job-insight/job-insight.component";
import { TimeSheetDetailsComponent } from "../time-sheet-details/time-sheet-details.component";
import { GoogleMap, MapPolyline } from "@angular/google-maps";
import { AppService } from "src/app/services/app/app.service";
import { TimeClockService } from "src/app/services/time-clock/time-clock.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { Filter } from "src/app/pages/filter/filter.model";
import * as moment from "moment";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SettingsComponent } from "../settings/settings.component";
import { ConfirmationModalComponent } from "src/app/pages/dialog-modal/confirmation-modal/confirmation-modal.component";
import { GlobalService } from "src/app/services/global/global.service";
import { NgxSpinnerService } from "ngx-spinner";
import { EditBreakTimeComponent } from "../edit-break-time/edit-break-time.component";
import { CookieService } from "ngx-cookie-service";
import { AddTimeForSpecificJobComponent } from "../add-time-for-specific-job/add-time-for-specific-job.component";
import { RecruiterService } from "src/app/services/recruiter/recruiter.service";
import { ConflictsComponent } from "../../conflicts/conflicts.component";
import { UserConflictsComponent } from "../user-conflicts/user-conflicts.component";
import { ViewEmployeeComponent } from "src/app/pages/view-employee/view-employee.component";
import { DeleteItemComponent } from "src/app/pages/delete-item/delete-item.component";
import { AddClockCardComponent } from "../add-clock-card/add-clock-card.component";
import { EditStEtComponent } from "../edit-st-et/edit-st-et.component";
import { JobService } from "src/app/services/job/job.service";

@Component({
  selector: "app-time-clock-dashboard",
  templateUrl: "./time-clock-dashboard.component.html",
  styleUrls: ["./time-clock-dashboard.component.scss"],
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0, height: 0, overflow: 'hidden' }),
        animate('300ms ease-in', style({ opacity: 1, height: '*', overflow: 'hidden' }))
      ]),
      transition(':leave', [
        style({ opacity: 1, height: '*', overflow: 'hidden' }),
        animate('300ms ease-out', style({ opacity: 0, height: 0, overflow: 'hidden' }))
      ])
    ]),
  ]
})
export class TimeClockDashboardComponent {
  public listView: boolean = true;
  public currentTab: string = "today";
  public currentSemiTab: string = "clock_request";
  public ifnot: boolean = false;
  isSpinnerLoading: boolean = false
  isSpinnerLoading2: boolean = false
  isSpinnerLoading3: boolean = false
  isSpinnerLoading4: boolean = false
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms" }
  // public currentTab: string = "timesheet";
  displayedColumnsF: string[] = [
    // "check-box",
    "name",
    "category",
    "address",
    "time",
    "break_time",
    "clock-in",
    "clock-out",
    "total-hours",
    "overtime",
    "status",
    "overtime_status",
    "accept-reject",
    "overtime_accept_reject",
  ];
  displayedColumns: string[] = [
    // "check-box",
    "name",
    "total-hours",
    "total-w-hours",
    "overtime",
    // "paid-time-off",
    "total-pay",
  ];
  displayedColumnsC: string[] = [
    "name",
    "company",
    "category",
    "date",
    "address",
    "shift-time",
    "phone-number",
    "action",
  ];

  displayedColJobInsight: string[] = ["category", "total_hour", "avg_hour", "action",];
  public dataSource = new MatTableDataSource();
  public dataSourceToday = new MatTableDataSource();
  public dataSourceTimeSheet = new MatTableDataSource();
  public dataSourceJobInsight: any[] = [];
  public dataSourceNotclockedIn = new MatTableDataSource();
  public googleMapLink = "https://www.google.com/maps?q=@";
  public dateForm!: FormGroup;
  public selectedDate!: any;
  public selectedNotClockedTodayDate!: any;
  public selectedTodayDate!: any;
  public paramsData: any;
  public companyArr: any[] = [];
  public filterObj: Filter = {
    operand: "or",
    arr: [],
  };
  public filterArr: any[] = [
    { key_name: "First Name", key_val: "first_name", type: "text" },
    { key_name: "Last Name", key_val: "last_name", type: "text" },
    { key_name: "Email", key_val: "email", type: "text" },
    { key_name: "Company", key_val: "id", type: 'select', value: this.companyArr, isCustomArray: true, field_name: "co_i" },
  ];
  public isFilterShow: boolean = false;
  public searchInput: string = "";
  private previousInputValue: string = "";
  public trackData: any[] = [];

  public pageSizeOptions = GlobalService.pageSizeOptions;
  public objData = {
    timesheet: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 1,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    today: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 1,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    not_clocked_tab: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 1,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    today_tracking: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 1,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
    job_insight: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 1,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 0,
    },
  };
  public filterMapData = [];
  isInitialized: boolean = false
  public insightUser = ""
  public insightUserPic = ""
  public mapData = [
    // {
    //     map: [
    //         { "lat": 50.772, "lng": -122.214, add: "Mota Varrachha Surat" },
    //         { "lat": 51.291, "lng": -157.821 },
    //         { "lat": -48.142, 'lng': 178.431 },
    //         { "lat": -37.467, "lng": 153.027, add: "Varrachha Surat" },
    //     ],
    //     first_name: "hiren",
    //     last_name: "fenton"
    // },
    // {
    //     map: [
    //         { "lat": -37.467, "lng": 153.027, add: "Mota Varrachha Surat" },
    //         { "lat": 31.291, "lng": -57.821 },
    //     ],
    //     first_name: "hiren",
    //     last_name: "fenton"
    // },
    // {
    //     map:[
    //         { lat: 50.772, lng: -122.214 },
    //         { lat: 51.291, lng: -157.821 },
    //         { lat: -48.142, lng: 178.431 },
    //         { lat: -37.467, lng: 153.027 },
    //     ],
    //      first_name:"vis",
    //     last_name:"upadhyay"
    // },
    // {
    //     map:[
    //         { lat: 37.772, lng: -122.214 },
    //         { lat: 21.291, lng: -157.821 },
    //         { lat: -18.142, lng: 178.431 },
    //         { lat: -27.467, lng: 153.027 },
    //     ],
    //     first_name:"vishva",
    //     last_name:"upadhyay"
    // }  
  ];
  public mapData2 = [
    {
      map: [
        { "lat": 50.772, "lng": -122.214, add: "Mota Varrachha Surat" },
        { "lat": 51.291, "lng": -157.821 },
        { "lat": -48.142, 'lng': 178.431 },
        { "lat": -37.467, "lng": 153.027, add: "Varrachha Surat" },
      ],
      first_name: "hiren",
      last_name: "fenton"
    },
    {
      map: [
        { "lat": -37.467, "lng": 153.027, add: "Mota Varrachha Surat" },
        { "lat": 31.291, "lng": -57.821 },
      ],
      first_name: "hiren",
      last_name: "fenton"
    },
    {
      map: [
        { lat: 50.772, lng: -122.214 },
        { lat: 51.291, lng: -157.821 },
        { lat: -48.142, lng: 178.431 },
        { lat: -37.467, lng: 153.027 },
      ],
      first_name: "vis",
      last_name: "upadhyay"
    },
    {
      map: [
        { lat: 37.772, lng: -122.214 },
        { lat: 21.291, lng: -157.821 },
        { lat: -18.142, lng: 178.431 },
        { lat: -27.467, lng: 153.027 },
      ],
      first_name: "vishva",
      last_name: "upadhyay"
    }
  ];
  public clockedVal: string = "all_activity";
  public clockData = {
    today_fill: 0,
    week_fill: 0,
    month_fill: 0,
    year_fill: 0,
    // tot_clockin_today: 0,
  };
  public tot_clockin_today;
  public searchObj = {
    today: {
      sh: "",
      filterArr: "",
    },
    timesheet: {
      sh: "",
      filterArr: "",
    },
  };
  public isAdmin: boolean = false;
  public isAddOption: boolean = false;
  public selectedEmp: any[] = [];
  constructor(
    private commonService: CommonService,
    private dialog: MatDialog,
    private appService: AppService,
    private timeClockService: TimeClockService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private router: Router,
    private spinner: NgxSpinnerService,
    private cookieService: CookieService,
    private recruiterService: RecruiterService,
    private jobService: JobService
  ) { }
  ngOnInit(): void {
    this.isInitialized = true;
    this.commonService.setTitle("Time Clock");
    this.activatedRoute.queryParams.subscribe((params) => {
      this.paramsData = params;
    });
    if (
      this.cookieService.get("user_id") &&
      window.location.href.includes("iframe")
    ) {
      this.appService.storeData(
        "training-portal.admin-authToken",
        this.cookieService.get("user_id")
      );
      this.appService.storeSessionData("isAdmin", JSON.stringify(true));
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    this.onToday();
    this.loadData();
    this.dateForm = this.fb.group({
      start: ["", Validators.required],
      end: ["", Validators.required],
    });
    setTimeout(() => {
      if (this.currentTab == "today" && document.getElementById("map")) {
        // this.initMap();
        this.getTodayData()
        this.getTodayList();
      }
    }, 100);
    this.getDefaultDate();
    this.dateForm.valueChanges.subscribe((value) => {
      const { start, end } = value;
      const startDate = new Date(start);
      const endDate = new Date(end);
      if (startDate > endDate) return;
      if (this.currentTab == "timesheet") {
        if (start && end) {
          this.getTimeSheetList();
          this.getJobInsight();
        }
      }
    });
  }
  getDefaultDate() {
    // this function is used to get the last 15 days data, end date is the today's date
    let endDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    var startdate;
    if (endDate) {
      startdate = moment().subtract(15, "days").format("yyyy-MM-DD");
    }
    this.dateForm.get("start")?.setValue(startdate);
    this.dateForm.get("end")?.setValue(endDate);
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(
      this.dateForm,
      controlName,
      validationType
    );
  }
  loadData(): void {
    // Example data; replace with actual data from your service or source
    const data = [
      {
        position: 1,
        fistName: "John",
        lastName: "doe",
        weight: "75kg",
        symbol: "JD",
      },
      {
        position: 2,
        fistName: "Jane",
        lastName: "doe",
        weight: "65kg",
        symbol: "JD",
      },
    ];
    this.dataSource.data = data; // Set the data for the dataSource
  }
  onTabChange(value) {

    this.currentTab = value;
    if (this.currentTab == "today") {
      this.getTodayList();
    } else {
      this.getTimeSheetList();
      this.getJobInsight();
      this.getSchedulerSetupData()
    }
  }
  onSemiTabChange(value) {
    this.currentSemiTab = value;
    if (this.currentSemiTab == "clock_request") {
      this.getTodayList();
    } else {
      this.getNotClockInList();
    }
  }
  onViewEmployee(id) {
    let data = {
      employee_id: id,
      type: 'company'
    }
    const dialogRef = this.dialog.open(ViewEmployeeComponent, {
      width: '95%',
      height: '95%',
      maxWidth: '95vw',
      panelClass: 'onboard-modal',
      data: data,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  // ====================Map changes
  initMap(): void {
    let mapConfig = {
      minZoom: 2.2,
      zoom: 7,
      mapTypeId: "terrain",
      streetViewControl: false,
      mapTypeControl: false,
      center:
        this.mapData.length > 0
          ? this.mapData[0]["map"][0]
          : { lat: 53.3118936, lng: -6.2765356 }, //byDefault Ireland location
    };

    let map = new google.maps.Map(
      document.getElementById("map") as HTMLElement,
      mapConfig
    );
    for (let i = 0; i < this.mapData.length; i++) {
      const flightPath = this.getFlightPathConst(this.mapData[i]["map"]);
      flightPath.setMap(map);
      const profilePicture = this.mapData[i]['profile_picture'];
      const name =
        this.mapData[i]["first_name"] + " " + this.mapData[i]["last_name"];
      this.addMarkersWithText(map, this.mapData[i]["map"], name, profilePicture, this.mapData[i]["cl_out"]);
    }
  }
  addMarkersWithText(map: google.maps.Map, path: any[], name: string, profilePicture: any, cl_out: any): void {
    const startMarker = new google.maps.Marker({
      position: path[0],
      map: map,
      title: path[0]?.add ? `${path[0].add}` : undefined,
      // label: {
      //   text: name + "(In)",
      //   color: "black",
      //   fontSize: "12px",
      //   fontWeight: "bold",
      // },
      icon: {
        url: "assets/images/icons/employee.png", // Use profile photo URL as icon
        // url: profilePicture ? profilePicture : "assets/images/icons/employee.png", // Use profile photo URL as icon
        scaledSize: new google.maps.Size(35, 35), // Adjust size if necessary
        labelOrigin: new google.maps.Point(20, 50), // Position label
      },

    });
    const startInfoWindow = new google.maps.InfoWindow({
      // content: `<div>Start of Segment ${i + 1}</div>`,
      content: `
      <div class='info-name'>${name} (In) </div>
      <div>${path?.[path.length - 1]?.add || undefined}</div>`,
    });
    startMarker.addListener("click", () => {
      startInfoWindow.open(map, startMarker);
    });
    startMarker.addListener("mouseover", () => {
      startInfoWindow.open(map, startMarker);
    });

    //Add dot markers for each coordinate in path
    // path.forEach((point, index) => {
    //   new google.maps.Marker({
    //     position: point,
    //     map: map,
    //     icon: {
    //       path: google.maps.SymbolPath.CIRCLE,
    //       scale: 5, // Adjust dot size
    //       fillColor: "blue",
    //       fillOpacity: 1,
    //       strokeWeight: 1,
    //     },
    //   });
    // });

    // 🔵 Add dot markers with hover info
    path.forEach((point, index) => {
      const dotMarker = new google.maps.Marker({
        position: point,
        map: map,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 5,
          fillColor: "blue",
          fillOpacity: 1,
          strokeWeight: 1,
        },
      });

      const dotInfoWindow = new google.maps.InfoWindow({
        content: `<div><strong>Point ${index + 1}</strong><br><br>Time: ${point.c_at}<br><br>${point.add || "No Address"}</div>`,
      });

      dotMarker.addListener("mouseover", () => dotInfoWindow.open(map, dotMarker));
      dotMarker.addListener("mouseout", () => dotInfoWindow.close());
      dotMarker.addListener("click", () => dotInfoWindow.open(map, dotMarker));
    });

    if (cl_out != 0) {
      // End marker with label and InfoWindow
      const endMarker = new google.maps.Marker({
        position: path[path.length - 1],
        map: map,
        title: `${path[path.length - 1]?.add}`,
        // label: {
        //   text: name + "Out",
        //   color: "black",
        //   fontSize: "12px",
        //   fontWeight: "bold",
        // },
        icon: {
          url: "assets/images/icons/employee.png", // Use profile photo URL as icon
          scaledSize: new google.maps.Size(35, 35), // Adjust size if necessary
          labelOrigin: new google.maps.Point(20, 50), // Position label
        },
      });
      const endInfoWindow = new google.maps.InfoWindow({
        // content: `<div>End of Segment ${i + 1}</div>`,
        content: `
        <div class='info-name'>${name} (Out)</div>
        <div>${path[path.length - 1]?.add}</div>`,
      });
      endMarker.addListener("click", () => {
        endInfoWindow.open(map, endMarker);
      });
    }
    // }
  }

  // addMarkersWithText(
  //   map: google.maps.Map,
  //   path: any[],
  //   name: string,
  //   profilePicture: any,
  //   cl_out: any
  // ): void {
  //   if (!path || path.length === 0) return;

  //   // Start marker with label and InfoWindow
  //   const startMarker = new google.maps.Marker({
  //     position: path[0],
  //     map: map,
  //     title: path[0]?.add ? `${path[0].add}` : undefined,
  //     label: {
  //       text: name + " (In)",
  //       color: "black",
  //       fontSize: "12px",
  //       fontWeight: "bold",
  //     },
  //     icon: {
  //       url: "assets/images/icons/employee.png",
  //       scaledSize: new google.maps.Size(35, 35),
  //       labelOrigin: new google.maps.Point(20, 50),
  //     },
  //   });

  //   const startInfoWindow = new google.maps.InfoWindow({
  //     content: `<div>${path?.[0]?.add || "No Address"}</div>`,
  //   });

  //   startMarker.addListener("click", () => {
  //     startInfoWindow.open(map, startMarker);
  //   });

  //   startMarker.addListener("mouseover", () => {
  //     startInfoWindow.open(map, startMarker);
  //   });

  //   // Add dot markers for each coordinate in path
  //   path.forEach((point, index) => {
  //     new google.maps.Marker({
  //       position: point,
  //       map: map,
  //       icon: {
  //         path: google.maps.SymbolPath.CIRCLE,
  //         scale: 5, // Adjust dot size
  //         fillColor: "blue",
  //         fillOpacity: 1,
  //         strokeWeight: 1,
  //       },
  //     });
  //   });

  //   // End marker if cl_out is not 0
  //   if (cl_out !== 0 && path.length > 1) {
  //     const endMarker = new google.maps.Marker({
  //       position: path[path.length - 1],
  //       map: map,
  //       title: `${path[path.length - 1]?.add}`,
  //       label: {
  //         text: name + " (Out)",
  //         color: "black",
  //         fontSize: "12px",
  //         fontWeight: "bold",
  //       },
  //       icon: {
  //         url: "assets/images/icons/employee.png",
  //         scaledSize: new google.maps.Size(35, 35),
  //         labelOrigin: new google.maps.Point(20, 50),
  //       },
  //     });

  //     const endInfoWindow = new google.maps.InfoWindow({
  //       content: `<div>${path[path.length - 1]?.add || "No Address"}</div>`,
  //     });

  //     endMarker.addListener("click", () => {
  //       endInfoWindow.open(map, endMarker);
  //     });
  //   }
  // }
  //   addMarkersWithText(
  //   map: google.maps.Map,
  //   path: any[],
  //   name: string,
  //   profilePicture: any,
  //   cl_out: any
  // ): void {
  //   if (!path || path.length === 0) return;

  //   // Start marker with label and InfoWindow
  //   const startMarker = new google.maps.Marker({
  //     position: path[0],
  //     map: map,
  //     title: path[0]?.add ? `${path[0].add}` : undefined,
  //     label: {
  //       text: name + " (In)",
  //       color: "black",
  //       fontSize: "12px",
  //       fontWeight: "bold",
  //     },
  //     icon: {
  //       url: "assets/images/icons/employee.png",
  //       scaledSize: new google.maps.Size(35, 35),
  //       labelOrigin: new google.maps.Point(20, 50),
  //     },
  //   });

  //   const startInfoWindow = new google.maps.InfoWindow({
  //     content: `<div>${path?.[0]?.add || "No Address"}</div>`,
  //   });

  //   startMarker.addListener("click", () => {
  //     startInfoWindow.open(map, startMarker);
  //   });

  //   startMarker.addListener("mouseover", () => {
  //     startInfoWindow.open(map, startMarker);
  //   });

  //   // Add dot markers for each coordinate in path
  //   path.forEach((point, index) => {
  //     const dotMarker = new google.maps.Marker({
  //       position: point,
  //       map: map,
  //       icon: {
  //         path: google.maps.SymbolPath.CIRCLE,
  //         scale: 5, // Adjust dot size
  //         fillColor: "blue",
  //         fillOpacity: 1,
  //         strokeWeight: 1,
  //       },
  //     });

  //     // InfoWindow for dot markers
  //     const dotInfoWindow = new google.maps.InfoWindow({
  //       content: `<div>Point ${index + 1}: <br>Lat: ${point.lat}, Lng: ${point.lng} <br> ${point?.add || "No Address"}</div>`,
  //     });

  //     dotMarker.addListener("click", () => {
  //       dotInfoWindow.open(map, dotMarker);
  //     });

  //     dotMarker.addListener("mouseover", () => {
  //       dotInfoWindow.open(map, dotMarker);
  //     });

  //     dotMarker.addListener("mouseout", () => {
  //       dotInfoWindow.close();
  //     });
  //   });

  //   // End marker if cl_out is not 0
  //   if (cl_out !== 0 && path.length > 1) {
  //     const endMarker = new google.maps.Marker({
  //       position: path[path.length - 1],
  //       map: map,
  //       title: `${path[path.length - 1]?.add}`,
  //       label: {
  //         text: name + " (Out)",
  //         color: "black",
  //         fontSize: "12px",
  //         fontWeight: "bold",
  //       },
  //       icon: {
  //         url: "assets/images/icons/employee.png",
  //         scaledSize: new google.maps.Size(35, 35),
  //         labelOrigin: new google.maps.Point(20, 50),
  //       },
  //     });

  //     const endInfoWindow = new google.maps.InfoWindow({
  //       content: `<div>${path[path.length - 1]?.add || "No Address"}</div>`,
  //     });

  //     endMarker.addListener("click", () => {
  //       endInfoWindow.open(map, endMarker);
  //     });
  //   }
  // }


  getFlightPathConst(flightPlanCoordinates) {
    const lineSymbol = {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      scale: 2,
    };
    const flightPath = new google.maps.Polyline({
      path: flightPlanCoordinates,
      geodesic: true,
      strokeColor: "#1a8fe3",
      strokeOpacity: 1.0,
      strokeWeight: 2,
      // strokeOpacity: 0,
      // strokeWeight: 0.1,
      icons: [
        {
          icon: lineSymbol,
          offset: "0",
          repeat: "10px",
        },
      ],
    });
    return flightPath;
  }
  // ============API calling =========================
  onCloseCal() {
    this.getTodayTrackData();
  }
  onCloseTodayCal() {
    this.getTodayList();
  }
  onCloseTodayNotClockedCal() {
    this.getNotClockInList();
  }

  onToday() {
    // this.selectedDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.selectedDate = new Date();
    this.selectedNotClockedTodayDate = new Date();
    this.selectedTodayDate = new Date();
    this.getTodayTrackData();
  }
  // =====================
  callApi(obj, type) {
    // this.filterObj = obj;
    this.objData[type].arr = obj.arr;
    this.objData[type].operand = obj.operand;
    this.onTabAPICall(type);
  }
  onFilterView(item) {
    this.objData[item]["isFilterShow"] = !this.objData[item]["isFilterShow"];
  }

  onSearch(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == "" && this.objData[type].previousInputValue !== "") {

      if (type == "today_tracking") {
        this.getTodayTrackData()
      } else {
        this.onTabAPICall(type);
      }

    }
  }

  onGo(type: string) {
    this.onTabAPICall(type);

  }

  openTimeSheetDetailsModel(item) {
    let objData = item;
    item["params"] = this.paramsData;
    const dialogRef = this.dialog.open(TimeSheetDetailsComponent, {
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "0",
      minWidth: "300px",
      width: "90%",
      height: "90%",
      maxWidth: "100%",
      data: objData,
      // maxHeight: '800px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {

      }
    });
  }

  openRequestModel() {
    const dialogRef = this.dialog.open(TimeClockRequestComponent, {
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      minWidth: "300px",
      width: "95%",
      height: "90%",
      maxWidth: "100%",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }
  onViewAllJobs(item) {
    const data = item;
    data["params"] = this.paramsData;
    const dialogRef = this.dialog.open(JobInsightComponent, {
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      minWidth: "300px",
      width: "95%",
      height: "90%",
      maxWidth: "100%",
      // maxHeight: '800px'
      data: data,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }
  onChangeView() {
    this.listView = !this.listView;
  }
  onCheckDetails(element) {

    this.insightUser = element.first_name + ' ' + element.last_name;
    this.insightUserPic = element.profile_picture;
    this.listView = !this.listView;
    this.getTodayTrackDataById(element.em_i);
  }
  searchTrackingUser() {
    this.getTodayTrackData()
  }
  getTodayTrackData() {
    let obj = {
      tc_id: this.paramsData.id,
      type: this.paramsData.type,
      date: this.datePipe.transform(this.selectedDate, "yyyy-MM-dd"),
      sh: this.objData.today_tracking.sh,
    };
    this.objData.today_tracking.previousInputValue = this.objData.today_tracking.sh;
    this.timeClockService.getTodayTracking(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.trackData = [];
          this.trackData = success.msg.rec;
          this.selectedEmp = [];
          this.trackData = this.trackData.map((item) => {
            item["selected"] = true;
            this.selectedEmp.push(item["em_i"]);
            return item;
          });
          this.mapData = [];
          this.mapData = success.msg.tr_data;
          this.filterMapData = JSON.parse(JSON.stringify(this.mapData));
          this.initMap();
          // setTimeout(()=>{
          //     this.initMap()
          // },2000)
        }
      },
      error: (error: any) => {
        this.trackData = [];
        this.selectedEmp = [];
        this.mapData = [];
        this.initMap();
        this.commonService.handleError(error);
      },
    });
  }
  getTodayTrackDataById(id: string) {
    let today = new Date();
    let formattedDate = today.toISOString().split("T")[0];
    let obj = {
      tc_id: this.paramsData.id,
      type: this.paramsData.type,
      date: formattedDate,
      em_i: id,
    };

    this.timeClockService.getTodayTrackingById(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.dataSourceJobInsight = success.msg;
        }
      },
      error: (error: any) => {
        // this.isSpinnerLoading = false
        this.commonService.handleError(error);
      },
    });
  }

  onOpenSetting() {
    const dialogRef = this.dialog.open(SettingsComponent, {
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      minWidth: "300px",
      width: "95%",
      height: "90%",
      maxWidth: "100%",
      data: { r_type: "2", u_t: "1", u_id: [] },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }
  confirmationAlert(dataObj: any, type: string, value: string) {

    let data = {
      j_id: dataObj.id,
      clock_id: dataObj.clock_id,
      em_i: dataObj.em_i,
      app: "",
      ov_ti_app: "",
    };
    if (type == "overtime") {
      data["ov_ti_app"] = value;
    } else {
      data["app"] = value;
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: {
        content_type: "accept_reject",
        dataObj: data,
        item_type: "time_clock_status",
        data_type: "change"
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirm_yes == true) {
        this.getTodayList();
      }
    });
  }
  onRouteSel(element) {

    this.mapData = [...this.filterMapData];
    this.mapData = this.mapData.filter(item => item["em_i"] === element.em_i);
    this.initMap();
  }
  onSelectAllEmp() {
    this.objData.today_tracking.sh = '';
    this.getTodayTrackData()

    // this.trackData = this.trackData.map((item) => {
    //   item["selected"] = true;
    //   this.selectedEmp.push(item["em_i"]);
    //   return item;
    // });
    // this.mapData = [...this.filterMapData];
    // this.initMap();
  }

  // ============================
  onPageSizeChange(event: Event, type: string) {
    const tar = event.target as HTMLInputElement;
    this.objData[type].itemsPerPage = Number(tar.value);
    this.objData[type].currentPage = 1;
    this.onTabAPICall(type);
  }

  onPageChange(number: number, type: string) {
    if (this.isInitialized) {
      this.isInitialized = false;
      return;
    }
    this.objData[type].currentPage = number;
    this.onTabAPICall(type);
  }

  onTabAPICall(type) {
    if (type == "today") {
      this.getTodayList();
    }
    else if (type == "not_clocked_tab") {
      this.getNotClockInList();
    }
    else if (type == "job_insight") {
      this.getJobInsight();
    }
    else {
      this.getTimeSheetList();
    }
  }

  getTodayData() {
    let obj = {
      filter_date: this.datePipe.transform(this.selectedTodayDate, "yyyy-MM-dd"),
      tc_id: this.paramsData.id,
      type: this.paramsData.type,
      f_a: this.objData.today.arr,
      // op_nd: this.objData.today.operand,
      // sh: this.objData.today.sh,
      // st: this.appService.startPageLogic(
      //   this.objData.today.currentPage,
      //   this.objData.today.itemsPerPage
      // ),
      // r_p: this.objData.today.itemsPerPage,
    };

    // this.dataSourceToday = new MatTableDataSource();
    // this.objData.today.previousInputValue = this.objData.today.sh;
    // this.spinner.show();
    // this.isSpinnerLoading = true
    this.timeClockService.getTodayData(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();

        if (success.status == 200) {
          // this.dataSourceToday = new MatTableDataSource(success.msg);
          // this.objData.today.count = success.count;
          // this.dataSourceToday = success.msg;
          this.clockData = {
            today_fill: success.today_fill,
            week_fill: success.week_fill,
            month_fill: success.month_fill,
            year_fill: success.year_fill,
            // tot_clockin_today: success.tot_clockin_today,
          };


          // this.dataSource = new MatTableDataSource(success.data)
          // this.dataSource.paginator = this.paginator;
          // this.dataSource.sort = this.sort;
        }
        // this.isSpinnerLoading = false
      },
      error: (error: any) => {
        // this.isSpinnerLoading = false
        this.commonService.handleError(error);
      },
    });
  }
  getTodayList() {
    let obj = {
      filter_date: this.datePipe.transform(this.selectedTodayDate, "yyyy-MM-dd"),
      tc_id: this.paramsData.id,
      type: this.paramsData.type,
      f_a: this.objData.today.arr,
      op_nd: this.objData.today.operand,
      sh: this.objData.today.sh,
      st: this.appService.startPageLogic(
        this.objData.today.currentPage,
        this.objData.today.itemsPerPage
      ),
      r_p: this.objData.today.itemsPerPage,
    };
     
    this.dataSourceToday = new MatTableDataSource();
    this.objData.today.previousInputValue = this.objData.today.sh;
    this.spinner.show();
    this.isSpinnerLoading = true
    this.timeClockService.getTodayList(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();

        if (success.status == 200) {
          this.dataSourceToday = new MatTableDataSource(success.msg);
          this.objData.today.count = success.count;

          this.tot_clockin_today = success.tot_clockin_today;

          // this.dataSource = new MatTableDataSource(success.data)
          // this.dataSource.paginator = this.paginator;
          // this.dataSource.sort = this.sort;
        }
        this.isSpinnerLoading = false
      },
      error: (error: any) => {
        this.isSpinnerLoading = false
        this.commonService.handleError(error);
      },
    });
  }
  getNotClockInList() {
    // selectedNotClockedTodayDate
    let obj = {
      st_dt: this.datePipe.transform(this.selectedNotClockedTodayDate, "yyyy-MM-dd"),
      tc_id: this.paramsData.id,
      type: this.paramsData.type,
      f_a: this.objData.not_clocked_tab.arr,
      op_nd: this.objData.not_clocked_tab.operand,
      sh: this.objData.not_clocked_tab.sh,
      st: this.appService.startPageLogic(
        this.objData.not_clocked_tab.currentPage,
        this.objData.not_clocked_tab.itemsPerPage,
      ),
      r_p: this.objData.not_clocked_tab.itemsPerPage,
    };
    this.dataSourceNotclockedIn = new MatTableDataSource();
    this.objData.not_clocked_tab.previousInputValue =
      this.objData.not_clocked_tab.sh;
    this.spinner.show();
    this.timeClockService.notclockInDate(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        //   this.isSpinnerLoading = false
        if (success.status == 200) {
          this.dataSourceNotclockedIn = new MatTableDataSource(success.msg);
          this.objData.not_clocked_tab.count = success.count;
        }
      },
      error: (error: any) => {
        //   this.isSpinnerLoading = false
        this.commonService.handleError(error);
      },
    });
  }
  getTimeSheetList() {
    let obj = {
      st_dt: this.datePipe.transform(
        this.dateForm.get("start")?.value,
        "yyyy-MM-dd"
      ),
      ed_dt: this.datePipe.transform(
        this.dateForm.get("end")?.value,
        "yyyy-MM-dd"
      ),
      tc_id: this.paramsData.id,
      type: this.paramsData.type,
      f_a: this.objData.timesheet.arr,
      op_nd: this.objData.timesheet.operand,
      sh: this.objData.timesheet.sh,
      st: this.appService.startPageLogic(
        this.objData.timesheet.currentPage,
        this.objData.timesheet.itemsPerPage
      ),
      r_p: this.objData.timesheet.itemsPerPage,
    };
    this.dataSourceTimeSheet = new MatTableDataSource();
    this.objData.timesheet.previousInputValue = this.objData.timesheet.sh;
    this.isSpinnerLoading = true;
    this.timeClockService.getTimesheet(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {

          this.dataSourceTimeSheet = new MatTableDataSource(success.msg);
          this.objData.timesheet.count = success.count;
        }
        this.isSpinnerLoading = false
      },
      error: (error: any) => {
        this.isSpinnerLoading = false
        this.commonService.handleError(error);
      },
    });
  }
  getJobInsight() {
    let obj = {
      st_dt: this.datePipe.transform(
        this.dateForm.get("start")?.value,
        "yyyy-MM-dd"
      ),
      ed_dt: this.datePipe.transform(
        this.dateForm.get("end")?.value,
        "yyyy-MM-dd"
      ),
      tc_id: this.paramsData.id,
      type: this.paramsData.type,

      f_a: this.objData.job_insight.arr,
      op_nd: this.objData.job_insight.operand,
      sh: this.objData.job_insight.sh,
      st: this.appService.startPageLogic(
        this.objData.job_insight.currentPage,
        this.objData.job_insight.itemsPerPage
      ),
      r_p: this.objData.job_insight.itemsPerPage,
    };
    this.objData.job_insight.previousInputValue = this.objData.job_insight.sh;
    this.isSpinnerLoading2 = true
    this.timeClockService.getJobInsight(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.dataSourceJobInsight = success.msg;
          this.objData.job_insight.count = success.count;
        }
        this.isSpinnerLoading2 = false

      },
      error: (error: any) => {
        this.isSpinnerLoading2 = false

        this.commonService.handleError(error);
      },
    });
  }

  onEditBreakTime(item) {
    if (item.ed_ti == "00:00:00") {
      this.appService.showToastMessage('error', "You cannot edit the break time because you have not clocked out yet.");
      return;
    }
    const dataObj = {
      em_i: item.em_i,
      clock_id: item.clock_id,
      j_id: item.id,
      date: item.date,
      br_tii: item.br_tii,
      br_tio: item.br_tio,
      st_ti: item.st_ti,
      ed_ti: item.ed_ti,
      type: "break",
    };
    const dialogRef = this.dialog.open(EditBreakTimeComponent, {
      minWidth: "300px",
      data: dataObj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
      this.getTodayList();
    });
  }

  onEditClockTime(item) {
    // if (item.ed_ti == "00:00:00") {
    //   this.appService.showToastMessage('error', "You cannot edit the time because you have not clocked out yet.");
    //   return;
    // }
    const dataObj = {
      em_i: item.em_i,
      clock_id: item.clock_id,
      j_id: item.id,
      date: item.date,
      br_tii: item.br_tii,
      br_tio: item.br_tio,
      st_ti: item.st_ti,
      ed_ti: item.ed_ti,
      type: "edit-clock-time",
    };
    const dialogRef = this.dialog.open(EditStEtComponent, {
      minWidth: "300px",
      data: dataObj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
      this.getTodayList();
    });
  }

  onBack() {
    if (this.isAdmin) {
      this.router.navigate(["/iframe/main-clock/"]);
    } else {
      this.router.navigate(["/rec/time-clock"]);
    }
  }

  onAddTimeForSpecificJob(element: any) {
    const dialogRef = this.dialog.open(AddTimeForSpecificJobComponent, {
      minWidth: "300px",
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      width: "55%",
      // height: '98%',
      maxWidth: "90vw",
      height: "90%",
      maxHeight: "100%",
      autoFocus: false,
      data: element,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  onValueChange(selectedValue: string): void {
    if (selectedValue == 'timesheet') {
      let obj = {
        st_dt: this.datePipe.transform(
          this.dateForm.get("start")?.value,
          "yyyy-MM-dd"
        ),
        ed_dt: this.datePipe.transform(
          this.dateForm.get("end")?.value,
          "yyyy-MM-dd"
        ),
        tc_id: this.paramsData.id,
        type: this.paramsData.type,
      };
      this.spinner.show();
      this.recruiterService.timesheetReport(obj).subscribe({
        next: (success: any) => {
          if (success.status == 200) {
            this.spinner.hide();
            this.appService.downloadFile(success.msg, 'timesheet');

          }
        },
        error: (error: any) => {
          this.spinner.hide();
          this.commonService.handleError(error);
        },
      });
    } else if (selectedValue == 'shift_report') {
      let obj = {
        st_dt: this.datePipe.transform(
          this.dateForm.get("start")?.value,
          "yyyy-MM-dd"
        ),
        ed_dt: this.datePipe.transform(
          this.dateForm.get("end")?.value,
          "yyyy-MM-dd"
        ),
      };

      this.spinner.show();
      this.recruiterService.shiftReport(obj).subscribe({
        next: (success: any) => {
          if (success.status == 200) {
            this.spinner.hide();
            this.appService.downloadFile(success.sheet, 'shiftreport');
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          this.commonService.handleError(error);
        },
      });
    }
  }
  openConflicts() {
    const dialogRef = this.dialog.open(UserConflictsComponent, {
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      width: '95%',
      height: '98%',
      maxWidth: '600px',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  @HostListener('document:click', ['$event'])
  onModelHide() {
    this.isAddOption = false;
  }

  onAddOption() {
    if (this.isAddOption) {
      this.isAddOption = !this.isAddOption;
    } else {
      setTimeout(() => {
        this.isAddOption = !this.isAddOption;
      }, 100)
    }
  }


  onDeleteCurrentData() {

    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_clock_card", id: this.paramsData.id }
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        // this.getList();
        this.router.navigate(['/rec/time-clock/']);
      }
    });
  }

  onAssign() {
    const dialogRef = this.dialog.open(AddClockCardComponent, Object.assign({
      width: '80%', height: '95%', maxWidth: '100vw', data: this.paramsData,
    }));
    dialogRef.afterClosed().subscribe((result) => {
      // this.getList();
    })
  }


  getSchedulerSetupData() {

    let data = {
      "st": "0",
      "r_p": "10",
      "v_t": "employee",
      f_a: [],
      op_nd: this.filterObj.operand,
      st_dt: this.datePipe.transform(
        this.dateForm.get("start")?.value,
        "yyyy-MM-dd"
      ),
      ed_dt: this.datePipe.transform(
        this.dateForm.get("end")?.value,
        "yyyy-MM-dd"
      ),
    }
    this.jobService.getSchedulerSetupDate(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {

          for (let i = 0; i < this.filterArr.length; i++) {
            if (this.filterArr[i]['key_name'] == "Company") {
              this.filterArr[i]["value"] = success["companies"]
            }

          }
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
}
